import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

/**
 * The per-business invoice page is gone; its job is the client filter on /invoices. A function
 * redirect is needed because a route parameter has to become a query parameter. A value that is not
 * a client id is passed through as is: the Invoices page ignores anything that is not a positive integer.
 */
export const invoicesByBusinessRedirect: RedirectFunction = ({ params }) =>
  inject(Router).createUrlTree(['/invoices'], { queryParams: { client: params['tenantId'] } });
